import axios from "axios";

import { DEFAULT_HEADERS } from "@/services/services.constants";
import {
  insertAcceptLanguageInterceptor,
  insertTokenInterceptor,
  responseErrorHandler,
  responseSuccessHandler,
} from "@/services/services.interceptors";

const authClient = axios.create({
  baseURL: String(import.meta.env.VITE_ARYA_AUTH_URL),
  headers: {
    ...DEFAULT_HEADERS,
  },
  timeout: 10000,
});

authClient.interceptors.request.use(insertTokenInterceptor);
authClient.interceptors.request.use(insertAcceptLanguageInterceptor);

authClient.interceptors.response.use(
  responseSuccessHandler,
  responseErrorHandler,
);

export default authClient;
